import { observer } from "mobx-react-lite";
import { Flex } from "@chakra-ui/react";

import { useFlags } from "@noli/business";

import { themeStore } from "@/stores/theme";
import BasicEditor from "./BasicEditor";
import DeletePanel from "./DeletePanel";
import DownloadPanel from "./DownloadPanel";
import SVGEditor from "./SVGEditor";
import ImageEditor from "./ImageEditor";
import TextEditor from "./TextEditor";
import NoliFrameEditor from "./NoliFrameEditor";
import NoliTextFrameEditor from "./NoliTextFrameEditor";
import GroupEditor from "./GroupEditor";
import MultipleEditor from "./MultipleEditor";
import BackgroundEditor from "./BackgroundEditor";
import RectangleEditor from "./RectangleEditor";
import NormalBrushEditor from "./NormalBrushEditor";
import PathEditor from "./PathEditor";
import LandscapeEditor from "./LandscapeEditor";
import { genBlock } from "@/utils/bem";
import { useScrollBar } from "@/hooks/useScrollbar";

const block = genBlock("c-node-editor");
function NodeEditor() {
  const { detailsTab } = useFlags();
  const { panelBg } = themeStore.styles;
  const { scrollBarProps } = useScrollBar();

  return (
    <Flex
      className={block()}
      // w="100%"
      // h="100%"
      flex="1"
      bg={panelBg}
      direction="column"
      alignItems="stretch"
      {...scrollBarProps}
    >
      {detailsTab === "background" ? <BackgroundEditor /> : <BasicEditor />}
      {detailsTab === "node" ? <DeletePanel /> : null}
      {detailsTab === "node" ? <DownloadPanel /> : null}
      {detailsTab === "node" ? (
        <Flex w="100%" flex={1} direction="column">
          <SVGEditor />
          <ImageEditor />
          <TextEditor />
          <NoliFrameEditor />
          <NoliTextFrameEditor />
          <GroupEditor />
          <MultipleEditor />
          <RectangleEditor />
          <NormalBrushEditor />
          <PathEditor />
          <LandscapeEditor />
        </Flex>
      ) : null}
    </Flex>
  );
}

export default observer(NodeEditor);
